import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { If } from "@componentsShared/Conditional/If";
var buttonVariants = {
  primary: "bg-primary-new text-white hover:bg-primary/90 cursor-pointer border-none",
  danger: "bg-[#F22C2C] text-white cursor-pointer border-none",
  secondary: "bg-gray-600 text-white hover:bg-gray-700 cursor-pointer border-none",
  outline: "bg-white border border-solid border-primary-new text-primary-new hover:bg-primary/10 cursor-pointer"
};
var ConfirmationButtons = function ConfirmationButtons(_ref) {
  var icon = _ref.icon,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Are you sure?" : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? "This action cannot be undone." : _ref$description,
    _ref$confirmButton = _ref.confirmButton,
    confirmButton = _ref$confirmButton === void 0 ? {
      text: "Confirm",
      variant: "danger"
    } : _ref$confirmButton,
    _ref$cancelButton = _ref.cancelButton,
    cancelButton = _ref$cancelButton === void 0 ? {
      text: "Cancel",
      variant: "outline"
    } : _ref$cancelButton;
  var getButtonClassName = function getButtonClassName(config) {
    var baseClasses = "w-full px-4 py-3 rounded-lg font-semibold text-base transition-colors text-center";
    var variantClasses = config.variant ? buttonVariants[config.variant] : "";
    return twMerge(baseClasses, variantClasses, config.className);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-confirmation-modal",
    className: "mt-8 flex flex-col gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement(If, {
    condition: !!icon
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-confirmation-icon",
    src: icon,
    alt: "Confirmation icon",
    width: "60",
    height: "60"
  }), /*#__PURE__*/React.createElement("h4", {
    id: "sell-car-confirmation-title",
    className: "font-bold text-xl leading-8 text-center text-primary-new"
  }, title))), /*#__PURE__*/React.createElement(If, {
    condition: !icon
  }, /*#__PURE__*/React.createElement("h4", {
    id: "sell-car-confirmation-title",
    className: "font-bold text-xl leading-8 text-center text-primary-new"
  }, title)), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-confirmation-description",
    className: "text-black-primary text-base leading-7 text-center"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    id: "sell-car-confirmation-confirm-btn",
    onClick: confirmButton.action,
    className: getButtonClassName(confirmButton)
  }, confirmButton.text), /*#__PURE__*/React.createElement("button", {
    id: "sell-car-confirmation-cancel-btn",
    onClick: cancelButton.action,
    className: getButtonClassName(cancelButton)
  }, cancelButton.text)));
};
export default ConfirmationButtons;